import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import Yup from '_zari/validation/_yup'

import { Button, Form, Modal } from '_zari/core'

import * as SociosSeguimientoService from 'services/sociosSeguimiento.service'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  _idSocio: Yup.string().required(),
  tema: Yup.string()
    .min(3)
    .max(200)
    .required()
})

const NuevoTemaSeguimientoModal = ({ handleClose, show, idSocio, onCreate }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      _idSocio: idSocio,
      tema: ''
    }),
    [idSocio]
  )

  const submitHandler = async data => {
    SociosSeguimientoService.nuevo(data)
      .then(() => {
        __zariContext.snack('success', 'El tema se ha creado.')
        if (onCreate) {
          onCreate()
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>NUEVO TEMA SEGUIMIENTO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <Modal.Body>
              <FormGroups.TemaFormGroup iError={errors.tema} iTouched={touched.tema} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevoTemaSeguimientoModal
